import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card } from 'react-bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import ListingReportsVendorContacts from 'components/ListingReportsVendorContacts';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import ExportTable from 'components/MarketingPlan/Form/ExportTable';
import { DashboardOutlined } from '@material-ui/icons';

const ReportVendorContact = () => {
  const defaultFilters = { search: '', per_page: 10, page: 1 };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({ data: [] });
  const [reportsExp, setReportsExp] = useState({ data: [] });
  const [load, setLoad] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setLoad(true);
    api
      .get('report-contacts', { params: { ...filters } })
      .then(({ data }) => {
        setReports(data);
        setLoad(true);
      });
    api
      .get('report-contacts-export', { params: { ...filters } })
      .then(({ data }) => setReportsExp(data));
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:vendor contacts report')}</h4>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Row>
              <Col>
                <ReactHTMLTableToExcel
                  id="test-table-xls-button"
                  className="btn btn-dark btn-sm"
                  sheet="Report Vendor Contacts"
                  filename="Report Vendor Contacts"
                  table="table-to-xls"
                  buttonText={t('label:export')}
                ></ReactHTMLTableToExcel>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ListingReportsVendorContacts
                  load={load}
                  reports={reports}
                  reportsExp={reportsExp}
                  filters={[]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  handleFilterChange={handleFilterChange}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

export default MasterPage(ReportVendorContact);
